import React, { useEffect } from 'react'
import mainlogo from "../Images/svg/Neoo search logo.svg"
import { NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getOwnProfile } from '../Redux/Slice/PostSlice'

const Sidebar = () => {
    const dispatch = useDispatch()
    const { UserProfileID } = useSelector((state) => state.app);
    const sidebarclose = () => {
        document.querySelector(".sidebardiv").style.cssText += "right: -350px";
    }

    useEffect(() => {
        dispatch(getOwnProfile())
    }, [])

    return (
        <>
            <section className="sidebardiv">
                <div className='sidetop'>

                    <div className='frtsalonlogo'>
                        <img src={mainlogo} alt="NeooSearch Logo" />
                    </div>

                    <div className='crosssideiocn' onClick={sidebarclose}>
                        <i className="fa-solid fa-xmark"></i>
                    </div>
                </div>
                <div className='sidebottom'>
                    <ul className='headermenulistul'>
                        <li className="ftrmenulistli">
                            <NavLink to="/about-neoo-search" className="listlnktxt" onClick={sidebarclose}>
                                About Us
                            </NavLink>
                        </li>
                        <li className="ftrmenulistli">
                            <NavLink to="/explore" className="listlnktxt" onClick={sidebarclose}>
                                Explore
                            </NavLink>
                        </li>
                        <li className="ftrmenulistli">
                            <NavLink to="/about-neoocard" className="listlnktxt" onClick={sidebarclose}>
                                NeooCard
                            </NavLink>
                        </li>
                        <li className="ftrmenulistli">
                            <NavLink to="/products-and-services" className="listlnktxt" onClick={sidebarclose}>
                                Products & services
                            </NavLink>
                        </li>

                        <li className="ftrmenulistli">
                            <NavLink to="/about-business-directory" className="listlnktxt" onClick={sidebarclose}>
                                About Local directory
                            </NavLink>
                        </li>

                        {<li className="ftrmenulistli">
                            <NavLink to="/business-reward-program" className="listlnktxt" onClick={sidebarclose}>
                                Rewards
                            </NavLink>
                        </li>}

                        {<li className="ftrmenulistli">
                            <NavLink to="/refer-and-earn" className="listlnktxt" onClick={sidebarclose}>
                                Refer & Earn
                            </NavLink>
                        </li>}

                        <li className="ftrmenulistli">
                            <NavLink to="/business-accelerator-program" className="listlnktxt" onClick={sidebarclose}>
                                BA Program
                            </NavLink>
                        </li>
                        <li className="ftrmenulistli">
                            <NavLink to="/terms-of-services" className="listlnktxt" onClick={sidebarclose}>
                                Terms of services
                            </NavLink>
                        </li>
                        <li className="ftrmenulistli">
                            <NavLink to="/user-agreement" className="listlnktxt" onClick={sidebarclose}>
                                User Agreement
                            </NavLink>
                        </li>
                        <li className="ftrmenulistli">
                            <NavLink to="/privacy-policy" className="listlnktxt" onClick={sidebarclose}>
                                Privacy policy
                            </NavLink>
                        </li>

                    </ul>
                </div>

            </section>
        </>
    )
}

export default Sidebar